/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ConnectThirdPartyAccountPayload = {
    calendarProvider?: ConnectThirdPartyAccountPayload.calendarProvider;
    meetingProvider?: ConnectThirdPartyAccountPayload.meetingProvider;
    type: ConnectThirdPartyAccountPayload.type;
    migrateMeetings?: boolean;
    returnPath?: string;
};
export namespace ConnectThirdPartyAccountPayload {
    export enum calendarProvider {
        GOOGLE = 'google',
        MICROSOFT = 'microsoft',
        ICAL = 'ical',
    }
    export enum meetingProvider {
        ZOOM = 'zoom',
        MICROSOFT_TEAMS = 'microsoft-teams',
        TEBUTO_MEET = 'tebuto-meet',
    }
    export enum type {
        CALENDAR = 'calendar',
        MEETING = 'meeting',
    }
}

